export class Formation {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Formation";
    this.scene = "Formation";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    this.data.push({
      name: "Team Code",
      value: {
        text: options.team?.code || "",
      },
    });

    this.data.push({
      name: "Team Type",
      value: {
        text:
          options?.game?.home_team?._id === options.team?._id ? "home" : "away",
      },
    });

    this.data.push({
      name: "Team Name",
      value: { text: options.team?.name || "" },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Team Video Badge",
      value: {
        video: "${user}" + options.team?.variables?.video_badge,
      },
    });

    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge,
      },
    });


    this.data.push({
      name: "Team Skyscraper Image",
      value: {
        image: "${user}" + options.team?.variables?.skyscraper,
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
    } else {
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
    }

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });

    this.data.push({
      name: "Competition Badge",
      value: { image: options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Stadium",
      value: {
        text:
          options.game?.stadium?.name || options.game?.stadium?.opta_name || "",
      },
    });

    let manager = options.manager;

    this.data.push({
      name: "Manager First Name Uppercase",
      value: {
        text: manager?.player?.first_name_upper || "",
      },
    });

    this.data.push({
      name: "Manager Last Name Uppercase",
      value: {
        text: manager?.player?.last_name_upper || "",
      },
    });

    this.data.push({
      name: "Manager Full Name",
      value: {
        text:
          (manager?.player?.first_name_upper || "") +
          " " +
          (manager?.player?.last_name_upper || ""),
      },
    });

    this.data.push({
      name: "Manager Title",
      value: {
        text: manager?.player?.title || "",
      },
    });

    let selector1 = options.selector1;

    this.data.push({
      name: "Selector 1 First Name Uppercase",
      value: {
        text: selector1?.player?.first_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 1 Last Name Uppercase",
      value: {
        text: selector1?.player?.last_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 1 Full Name",
      value: {
        text:
          (selector1?.player?.first_name_upper || "") +
          " " +
          (selector1?.player?.last_name_upper || ""),
      },
    });

    this.data.push({
      name: "Selector 1 Title",
      value: {
        text: selector1?.player?.title || "",
      },
    });

    let selector2 = options.selector2;

    this.data.push({
      name: "Selector 2 First Name Uppercase",
      value: {
        text: selector2?.player?.first_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 2 Last Name Uppercase",
      value: {
        text: selector2?.player?.last_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 2 Full Name",
      value: {
        text:
          (selector2?.player?.first_name_upper || "") +
          " " +
          (selector2?.player?.last_name_upper || ""),
      },
    });

    this.data.push({
      name: "Selector 2 Title",
      value: {
        text: selector2?.player?.title || "",
      },
    });

    let selector3 = options.selector3;

    this.data.push({
      name: "Selector 3 First Name Uppercase",
      value: {
        text: selector3?.player?.first_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 3 Last Name Uppercase",
      value: {
        text: selector3?.player?.last_name_upper || "",
      },
    });

    this.data.push({
      name: "Selector 3 Full Name",
      value: {
        text:
          (selector3?.player?.first_name_upper || "") +
          " " +
          (selector3?.player?.last_name_upper || ""),
      },
    });

    this.data.push({
      name: "Selector 3 Title",
      value: {
        text: selector3?.player?.title || "",
      },
    });

    new Array(15).fill(1).forEach((_, index) => {
      let row = index + 1;

      let player = options.squads?.find((s) => s.order === row);

      this.data.push({
        name: "Last Name Uppercase " + row,
        value: {
          text: player?.squad?.player?.last_name_upper || "",
        },
      });

      this.data.push({
        name: "Last Name " + row,
        value: {
          text: player?.squad?.player?.last_name || "",
        },
      });

      this.data.push({
        name: "First Name Uppercase " + row,
        value: {
          text: player?.squad?.player?.first_name_upper || "",
        },
      });

      this.data.push({
        name: "First Name " + row,
        value: {
          text: player?.squad?.player?.first_name || "",
        },
      });

      this.data.push({
        name: "Short Name " + row,
        value: {
          text: player?.squad?.player?.short_name || player?.squad?.player?.first_name[0] + '. ' + player?.squad?.player?.last_name || "",
        },
      });

      this.data.push({
        name: "Short Name Uppercase" + row,
        value: {
          text: player?.squad?.player?.short_name_upper || player?.squad?.player?.first_name_upper[0] + '. ' + player?.squad?.player?.last_name_upper || "",
        },
      });

      this.data.push({
        name: "Captain " + row,
        value: {
          visible: player?.captain || false,
        },
      });
      this.data.push({
        name: "Position " + row,
        value: {
          text: player?.squad?.position || "",
        },
      });
      this.data.push({
        name: "Shirt Number " + row,
        value: {
          text: player?.squad?.shirt_number || "",
        },
      });

      // this.data.push({
      //   name: "X/Y " + row,
      //   value: {
      //     position: {
      //       x: options.formation.positions[index].x,
      //       y: options.formation.positions[index].y,
      //     },
      //   },
      // });
    });

    new Array(19).fill(1).forEach((_, index) => {
      let row = index + 12;

      let player = options.squads?.find((s) => s.order === row);

      this.data.push({
        name: "Last Name Uppercase " + row,
        value: {
          text: player?.squad?.player?.last_name_upper || "",
        },
      });

      this.data.push({
        name: "Captain " + row,
        value: {
          visible: player?.captain || false,
        },
      });
      this.data.push({
        name: "Position " + row,
        value: {
          text: player?.squad?.position || "",
        },
      });
      this.data.push({
        name: "Shirt Number " + row,
        value: {
          text: player?.squad?.shirt_number || "",
        },
      });

      // this.data.push({
      //   name: "X/Y " + row,
      //   value: {
      //     position: {
      //       x: options.formation?.positions?.[index]?.x,
      //       y: options.formation?.positions?.[index]?.y,
      //     },
      //   },
      // });
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
